import React from "react";
import { Link } from "react-router-dom";
import {
  Twitter,
  Instagram,
  Linkedin,
  Facebook,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { ArrowRight, Minus } from "lucide-react";
import { Grid } from "../../ui/Grid";

const SolutionsFooter = () => {
  return (
    <>
      <footer className="bg-gradient-to-b from-gold/10 to-transparent w-full relative z-10 mb-14 lg:mb-0">
        <div className="bg-[radial-gradient(closest-side,theme(colors.gold),theme(colors.gold),transparent)] h-[2px]"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="space-y-4">
              <Link
                className="flex-none text-xl font-semibold text-white focus:outline-hidden focus:opacity-80"
                href="#"
                aria-label="Brand"
              >
                <img
                  src="/images/solutions/mini-logo.png"
                  height={150}
                  width={150}
                  alt="main logo"
                  loading="lazy"
                  className="relative object-cover"
                />
              </Link>
              <p className="text-gray-400 mt-4 text-sm ">
                Scan Global Solutions provides innovative technology services to
                businesses worldwide, helping them navigate the digital
                landscape with confidence.
              </p>
              <div className="flex space-x-4 mt-4">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <Facebook size={20} />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <Twitter size={20} />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/scan-global-solutions-uae/"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <Linkedin size={20} />
                </a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/scanglobalsolutions?igsh=MTV6MzA3NmMzcDFsbQ=="
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {[
                  { name: "Holdings", path: "/" },
                  { name: "What We Do", path: "/solutions/what-we-do" },
                  { name: "What We Offer", path: "/solutions/what-we-offer" },
                  { name: "Contact Us", path: "/solutions/contact" },
                ].map((item) => (
                  <li
                    key={item.name}
                    className="transition-transform duration-300 ease-in-out hover:translate-x-2"
                  >
                    <Link
                      to={item.path}
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                {[
                  { name: "Business Immigration", path: "#" },
                  { name: "Advisory Services", path: "#" },
                  { name: "CFO Services", path: "#" },
                  { name: "Global Business Setup", path: "#" },
                  { name: "Business Brokerage", path: "#" },
                  { name: "Mergers and Acquisitions", path: "#" },
                ].map((item) => (
                  <li
                    key={item.name}
                    className="transition-transform duration-300 ease-in-out hover:translate-x-2"
                  >
                    <a
                      href={item.path}
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-5">
                {/* Dubai Office */}
                <li className="flex items-start">
                  <MapPin className="h-5 w-5 text-gold mr-3 mt-1 flex-shrink-0" />
                  <address className="not-italic text-gray-400 text-sm leading-relaxed">
                    <p className="font-bold text-base text-gray-600">
                      Dubai Office
                    </p>
                    The Meydan Hotel, Grandstand, <br />
                    6th Floor, Meydan Road, Nad Al Sheba, <br />
                    Dubai, UAE
                  </address>
                </li>

                {/* Canada Office */}
                <li className="flex items-start">
                  <MapPin className="h-5 w-5 text-gold mr-3 mt-1 flex-shrink-0" />
                  <address className="not-italic text-gray-400 text-sm leading-relaxed">
                    <p className="font-bold text-base text-gray-600">
                      Canada Office
                    </p>
                    Unit 208/209, 3485 Rebecca St, <br />
                    Oakville, Ontario, Canada L6L 0H4
                  </address>
                </li>

                {/* Phone */}
                <li className="flex items-center">
                  <Phone className="h-5 w-5 text-gold mr-3 flex-shrink-0" />
                  <a
                    href="tel:+971527947540"
                    className="text-gray-400 text-sm hover:text-gray-600"
                  >
                    +971 52 794 7540
                  </a>
                </li>

                {/* Email */}
                <li className="flex items-center">
                  <Mail className="h-5 w-5 text-gold mr-3 flex-shrink-0" />
                  <a
                    href="mailto:admin@scanglobal.me"
                    className="text-gray-400 text-sm hover:text-gray-600"
                  >
                    admin@scanglobal.me
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-300/20 mt-12 pt-8 pb-3">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                &copy; {new Date().getFullYear()} Scan Global Solutions. All
                rights reserved.
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                >
                  Privacy Policy
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                >
                  Terms of Service
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
                >
                  Sitemap
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* bg-gradient-to-b from-yellow-900/10 to-transparent bg-black */}
        {/* <div className="bg-[radial-gradient(closest-side,theme(colors.gold),theme(colors.gold),transparent)] h-[2px]"></div> */}
      </footer>
    </>
  );
};

export default SolutionsFooter;
